import {
  GqlModel,
  GqlQueryModel,
  GqlMutationModel,
  GqlModelListOperator,
  GqlModelOperator,
} from "../graphql/graphql.model";
import gql from "graphql-tag";
import {FormGroup} from "@angular/forms";
import {QuickFormGroup} from "../helpers/quick-form-group";
import {jsonProperty} from "../json.model";
import {toNumber} from "../helpers/helpers";
import {SuccessResultGqlModel} from "../graphql/common.gql-model";

export class AppAlertGqlModel extends GqlQueryModel {
  static mapper: GqlModelListOperator<AppAlertGqlModel> = GqlModel.buildListMapper(AppAlertGqlModel, "alerts");

  static query = gql`
subscription alerts {
  alerts {
    id
    header
    footer
    text
    bulletPoints
    priority
  }
}
  `;

  @jsonProperty("string") id: string;
  @jsonProperty("string") header: string;
  @jsonProperty("string") footer: string;
  @jsonProperty("string") text: string;
  @jsonProperty("string") bulletPoints: string;
  @jsonProperty(AppAlertGqlModel.getPriority) priority: number;
  @jsonProperty(AppAlertGqlModel.getControlsHeight) controlsHeight: number;

  @jsonProperty(AppAlertGqlModel.getBulletPointsList) bulletPointsList: string[];

  formGroup: FormGroup;

  static getBulletPointsList(value: any, data: any, instance: AppAlertGqlModel): string[] {
    if (instance.bulletPoints) {
      return instance.bulletPoints.split(/[\r\n\s]+/);
    }

    return [];
  }

  static getPriority(value: any): number {
    return toNumber(value, 99);
  }

  static getControlsHeight(value: any, data: any, instance: AppAlertGqlModel): number {
    return 3 +
      (instance.bulletPoints ? 1 : 0) +
      (instance.footer ? 1 : 0) +
      (instance.id ? 1 : 0);
  }

  constructor(data: any) {
    super(data);

    this.formGroup = new QuickFormGroup(this, ["header", "footer", "text", "bulletPoints", "priority"]);
  }
}

export class AppAlertInputDataGqlModel extends GqlModel {
  @jsonProperty("string") id: string;
  @jsonProperty("string") header: string;
  @jsonProperty("string") footer: string;
  @jsonProperty("string") text: string;
  @jsonProperty("string") bulletPoints: string;
  @jsonProperty("number") priority: string;
}

export class AppAlertInputGqlModel extends GqlMutationModel {
  static mapper: GqlModelOperator<SuccessResultGqlModel> = GqlModel.buildMapper(SuccessResultGqlModel, "alert");

  static query = gql`
    mutation alert($alert: AppAlertInput!, $remove: Boolean) {
      alert: alert(alert: $alert, remove: $remove) {
        success
      }
    }
  `;

  @jsonProperty(AppAlertInputDataGqlModel) alert: AppAlertInputDataGqlModel;
  @jsonProperty("boolean") remove: boolean;
}
